import _ from 'lodash';
import { API_ERROR_MSG } from './constants';
import { HeaderData } from './types';

export const areHeadersDifferent = (
  clientHeaders: HeaderData,
  localHeaders: HeaderData
): boolean =>
  clientHeaders['x-enterprise-id'] !== localHeaders['x-enterprise-id'] ||
  clientHeaders['x-store-id'] !== localHeaders['x-store-id'] ||
  clientHeaders['remote-user'] !== localHeaders['remote-user'] ||
  clientHeaders['x-department-name'] !== localHeaders['x-department-name'] ||
  clientHeaders.authorization !== localHeaders.authorization;

/**
 *
 * @ [key:string] :string
 * returns Type string
 * [desc]: Branch specific deployment strategy has dev,stage and prod environment
 *         and base url updates per environment.
 *  develop: us-dev
 *  stage: us-stage
 *  master: us-prod
 *  @techDebt : .env.okta  has to be fixed
 *
 */

export const validateCompanyAndStore = (
  companyId?: string,
  storeId?: string
): void => {
  if (_.isEmpty(storeId)) {
    throw new Error(API_ERROR_MSG.MISSING_STORE_ID);
  }
  if (_.isEmpty(companyId)) {
    throw new Error(API_ERROR_MSG.MISSING_COMPANY_ID);
  }
};

export const isStoreAvailable = (storeId: string): boolean =>
  !_.isEmpty(storeId);

export const getErrorMessage = (message: string): string => {
  const separatorPosition = message?.split(':', 2)?.join(':')?.length;
  return separatorPosition
    ? message.slice(separatorPosition + 1, message?.length).trim()
    : '';
};
